/**
 * Typy opracowań (enum StudyType) zgrupowane tak, jak mówi się o nich w biurze: „robi operaty",
 * „robi KIP-y". Używane w profilu pracownika (jakie opracowania wykonuje) i na tablicy zadań
 * (komu pokazać zadanie do przyjęcia). Kolejność i skróty jak w StudyType.java.
 */
export interface StudyTypeGroup {
  key: string;
  label: string;
  /** Kody enuma StudyType należące do grupy. */
  types: string[];
}

export const STUDY_TYPE_GROUPS: StudyTypeGroup[] = [
  { key: 'PRG', label: 'Projekty robót geologicznych', types: ['PRG_1A', 'PRG_1B', 'PRG_1C'] },
  { key: 'KIP', label: 'Decyzje środowiskowe (KIP)', types: ['KIP_2'] },
  { key: 'Op-wod', label: 'Operaty wodnoprawne', types: ['OP_WOD_3A', 'OP_WOD_3B', 'OP_WOD_3C'] },
  { key: 'Dok-hydro', label: 'Dokumentacje hydrogeologiczne', types: ['DOK_HYDRO_4A', 'DOK_HYDRO_4B', 'DOK_HYDRO_4C'] },
  { key: 'Dok-likw', label: 'Dokumentacje z likwidacji otworów', types: ['DOK_LIKW_5'] },
  { key: 'An-ryz', label: 'Analizy ryzyka', types: ['ANALIZA_RYZYKA_6'] },
  { key: 'Plan-bezp', label: 'Plany bezpieczeństwa wody', types: ['PLAN_BEZP_7'] },
  { key: 'Plan-ruchu', label: 'Plany ruchu', types: ['PLAN_RUCHU_8'] },
];

/** Pełne nazwy pojedynczych typów — do wyboru typu zadania i podpowiedzi na karcie. */
export const STUDY_TYPE_LABELS: Record<string, string> = {
  PRG_1A: '1a — PRG: wykonanie otworu',
  PRG_1B: '1b — PRG: likwidacja',
  PRG_1C: '1c — PRG: rekonstrukcja',
  KIP_2: '2 — Karta informacyjna przedsięwzięcia (KIP)',
  OP_WOD_3A: '3a — Operat wodnoprawny: urządzenie wodne',
  OP_WOD_3B: '3b — Operat wodnoprawny: pobór wód',
  OP_WOD_3C: '3c — Operat wodnoprawny: odprowadzenie',
  DOK_HYDRO_4A: '4a — Dok. hydrogeol.: zasoby eksploatacyjne',
  DOK_HYDRO_4B: '4b — Dok. hydrogeol.: wydajność otworów',
  DOK_HYDRO_4C: '4c — Dok. hydrogeol.: strefy ochronne',
  DOK_LIKW_5: '5 — Dok. geol. z likwidacji otworu',
  ANALIZA_RYZYKA_6: '6 — Analiza ryzyka',
  PLAN_BEZP_7: '7 — Plan bezpieczeństwa wody (WSP)',
  PLAN_RUCHU_8: '8 — Plan ruchu',
};

/** Grupa, do której należy typ — skrót na kartę zadania. */
export function studyTypeGroup(type: string | null | undefined): StudyTypeGroup | undefined {
  return type ? STUDY_TYPE_GROUPS.find(g => g.types.includes(type)) : undefined;
}
